<template>
  <div class="box3-container">
    <div class="content">
      <div id="assetChart" :style="{width: '100%', height: '100%'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box3',
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          online: 0,
          Offline: 0
        }
      }
    }
  },
  data() {
    return {
      assetData: {
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'top',
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          }
        },
        series: [
          {
          name: this.$t("home.box2.text1"),
          type: 'pie',
          radius: ['25%','41%'],
          center: ['40%','60%'],
          label: {
            alignTo: 'edge',
            normal: {
              position: 'outside',    // 标签的位置。'outside'饼图扇区外侧，通过视觉引导线连到相应的扇区。'inside','inner' 同 'inside',饼图扇区内部。'center'在饼图中心位置。
              formatter: '{text|{b}}\n{value|{c}}{unit|'+this.$t("home.box2.unit")+'}',
              rich: {
                text: {
                  fontSize: 10,
                  lineHeight: 1,
                  color: '#fff',
                  padding: 0
                },
                value: {
                  fontSize: 20,
                  color: '#fff',
                  fontFamily: 'Bahnschrift',
                  padding: 5
                },
                unit: {
                  fontSize: 10,
                  color: '#fff'
                }
              }
            },
            
          },
          labelLine: {
            length: -50,  // 在 label 位置 设置为'outside'的时候会显示视觉引导线。
            length2: 110, // 视觉引导项第二段的长度。
          },
          data: [
            {
              name: this.$t("home.box2.text1"),
              value: 8,
              itemStyle: {
                color: '#144f89'
              }
            }
          ]
        },{
            name: this.$t("home.box2.title"),
            type: 'pie',
            radius: ['40%','60%'],
            center: ['40%','60%'],
            label: {
              alignTo: 'edge',
              normal: {
                position: 'outside',    // 标签的位置。'outside'饼图扇区外侧，通过视觉引导线连到相应的扇区。'inside','inner' 同 'inside',饼图扇区内部。'center'在饼图中心位置。
                formatter: '{text|{b}}\n{value|{c}}{unit|'+this.$t("home.box2.unit")+'}',
                rich: {
                  text: {
                    fontSize: 10,
                    lineHeight: 1,
                    color: '#fff',
                    padding: 0
                  },
                  value: {
                    fontSize: 20,
                    color: '#fff',
                    fontFamily: 'Bahnschrift',
                    padding: 5
                  },
                  unit: {
                    fontSize: 10,
                    color: '#fff'
                  }
                }
              },
              
            },
            labelLine: {
              length: 0,  // 在 label 位置 设置为'outside'的时候会显示视觉引导线。
              length2: 15 // 视觉引导项第二段的长度。
            },
            data: [{
                name: this.$t("home.box2.text2"),
                value: 5,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0,
                            color: '#ffd545' // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: '#e2a100' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                    }
                }
            },
            {
                name: this.$t("home.box2.text3"),
                value: 3,
                itemStyle: {
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0,
                            color: '#2285eb' // 0% 处的颜色
                        }, {
                            offset: 1,
                            color: '#56cbff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                    }
                }
            }]
        }]

      }
    }
  },
  watch: {
    itemData: {
      handler(newVal, oldVal) {
        if(oldVal){
          if(newVal.online!=oldVal.online||newVal.total!=oldVal.total){
            this.drawChart()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    drawChart () {
      this.assetData.series[0].data[0].value=this.itemData.total
      this.assetData.series[1].data[0].value=this.itemData.online
      this.assetData.series[1].data[1].value=this.itemData.Offline
      var assetChart = this.$echarts.init(document.getElementById('assetChart'))
      assetChart.clear()
      // 绘制图表
      assetChart.setOption(this.assetData)
    }
  },
  mounted () {
    this.drawChart()
  }
}
</script>
<style lang='less'>
.box3-container {
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 10px;
  }
}
</style>
